<template>
  <div class="debug" v-if="true">
    <b-button class="mt-1" size="xl" variant="danger" v-b-modal.debug><b-icon icon="code-slash" font-scale="1.3"></b-icon></b-button>
    <b-modal id="debug" title="Debug" size="xl">
      <pre>{{dialogState}}</pre>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'Debug',
  data() {
    return {
      debug: process.env.VUE_APP_DEBUG
    };
  },
  computed: {
    dialogState () {
      return this.$store.state.dialogState;
    }
  },
  methods: {

  }
}
</script>

<style scoped>
  .debug {
    float: right;
  }
</style>
